import { C as S } from "./colors-C72eWVhK.js";
import { FONT_SIZES as T, FONT_WEIGHTS as o, LINE_HEIGHTS as e, MOTION_CONFIG as E, SCREEN_WIDTHS as _, SPACE as r, TEXT_SIZES as t } from "./common/themes/constants/constants.mjs";
const N = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  COLORS: S,
  FONT_SIZES: T,
  FONT_WEIGHTS: o,
  LINE_HEIGHTS: e,
  MOTION_CONFIG: E,
  SCREEN_WIDTHS: _,
  SPACE: r,
  TEXT_SIZES: t
}, Symbol.toStringTag, { value: "Module" }));
export {
  N as T
};
